import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { API_URL_TEST } from "../constants/constants";

const headers = new Headers()
headers.append('Content-Type', 'application/json');
headers.append('Access-Control-Allow-Origin', '*');

export const useConfig = () => useFetch<any>(API_URL_TEST + '/Customizations/backoffice', { headers })?.data

export const useLanguages = () => useFetch<any>(API_URL_TEST + '/Languages/backoffice', { headers })?.data

export const usewebAgentsLanguages = () => useFetch<any>(API_URL_TEST + '/Languages/webagent', { headers })?.data
